<template>
  <vue-draggable-resizable
    :w="width"
    :h="height"
    :x="posX"
    :y="posY"
    :min-height="217"
    :active="true"
    :parent="true"
    :resizable="true"
    @resizing="onResizing"
    class="home-form-container elevation-2"
    class-name-handle="object-form-resizable-handle"
    :drag-handle="'.drag'"
    data-app
  >
    <multiple-objects-selected-window
      :is-multi-select="true"
      :tabs="tabs"
      :active-tab="activeTab"
      :height="height"
      :width="width"
      @closeForm="tryCloseForm"
      @startTabChange="startTabChange"
    />

    <app-dialog-box
      :open="changeTabDialogIsOpen"
      :title="$t('ChangeTab')"
      :content="
        $t('UnsavedChanges') +
          '\n' +
          $t('CheckTabChange') +
          '\n' +
          $t('ChangesWillBeLost')
      "
      :main-action-label="$t('No')"
      @mainAction="changeTabDialogIsOpen = false"
      @secondaryAction="confirmTabChange"
      :secondary-action-label="$t('Yes')"
    />

    <app-dialog-box
      :open="closeDialogIsOpen"
      :title="$t('ClosingForm')"
      :content="
        $t('UnsavedChanges') +
          '\n' +
          $t('CheckCloseForm') +
          '\n' +
          $t('ChangesWillBeLost')
      "
      :main-action-label="$t('No')"
      @mainAction="closeDialogIsOpen = false"
      :secondary-action-label="$t('Yes')"
      @secondaryAction="closeForm()"
    />
  </vue-draggable-resizable>
</template>

<script>
import { bus } from "@/main";
import WindowHeaderButton from "../../../_Atoms/WindowHeaderButton";
import AppDialogBox from "../../../_Molecules/AppDialogBox";
import FormRequired from "../_Atoms/FormRequired";
import MultiSelectionTab from "./MultiSelectionTab";
import MultipleObjectsSelectedWindow from "@/components/Home/Forms/MultipleObjectsSelectedWindow";

export default {
  name: "MultiSelectionForm",

  components: {
    MultipleObjectsSelectedWindow,
    MultiSelectionTab,
    FormRequired,
    AppDialogBox,
    WindowHeaderButton
  },

  data() {
    return {
      posY: undefined,
      posX: undefined,
      width: 700,
      height: 400,

      tabs: [],
      activeTab: 0,
      disableTabs: false,

      dataUnsaved: false,
      clickedTab: undefined,
      changeTabDialogIsOpen: false,
      closeDialogIsOpen: false
    };
  },

  mounted() {
    this.$nextTick(() => {
      // Sets the initial position of the form (centers it)
      this.setInitialPosition();
    });
    this.tabs = this.$store.getters.getMultiObjectSelection.layers;

    /**
     * Opens a channel to receive updates on the edition state of the objects
     */
    bus.$on(
      "multiple-selection-update-edition-state",
      objectsAreEdited => (this.dataUnsaved = objectsAreEdited)
    );
  },

  destroyed() {
    bus.$off("multiple-selection-update-edition-state");
  },

  methods: {
    onResizing(left, top, width, height) {
      this.height = height;
      this.width = width;
    },

    /**
     * Defines the initial position of the current component.
     */
    setInitialPosition() {
      let mapElement = this.$parent.$refs.map;
      this.posX = Math.round((mapElement.offsetWidth - this.width) / 2);
      this.posY = Math.round(0);
    },

    tryCloseForm() {
      if (this.dataUnsaved) {
        this.closeDialogIsOpen = true;
      } else {
        this.closeForm();
      }
    },

    /** Emits an event to close this component's window **/
    closeForm() {
      bus.$emit("remove-highlight-from-selected-table");
      this.$store.dispatch("CLEAR_MULTI_OBJECT_SELECTION_DATA");
      this.$emit("closeForm");
    },

    /**
     * Initiates the process of changing tabs.
     * @param {Number} index - index of the clicked tab
     */
    startTabChange(index) {
      if (index !== this.activeTab) {
        this.clickedTab = index;
        if (this.dataUnsaved) {
          this.changeTabDialogIsOpen = true;
        } else {
          this.changeTab();
        }
      }
    },

    /**
     *Changes the tab and closes the dialog box.
     */
    confirmTabChange() {
      this.changeTab();
      this.changeTabDialogIsOpen = false;
    },

    /**
     * Changes the tab from the current one to the one clicked.
     */
    changeTab() {
      bus.$emit("startEditSelectedDeactivation", "fromTab");
      bus.$emit("remove-highlight-from-selected-table");
      this.activeTab = this.clickedTab;
      this.clickedTab = undefined;
    }
  }
};
</script>

<style scoped>
.home-form-container {
  min-width: 500px !important;
  z-index: 150 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/MultiSelectionForm/MultiSelectionForm.vue